import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import './CollapseBase.less';

class CollapseBase extends Component {
    static propTypes = {
        /** Flag to determine if the component is expanded or not on mount */
        expanded: PropTypes.bool,
        /** The CSS line-height of the content, used to calculate how many rows to display. Defaults to 22. You will likely not need to adjust this. */
        lineHeight: PropTypes.number,
        /** Total number of line rows (ems) to display when compact. Defaults to 0. */
        lines: PropTypes.number,
        /** Optional event handler to trigger when the component expands or collapses.  Passes the isExpanded boolean as a parameter */
        onExpandedChange: PropTypes.func,
        /** The CSS padding-bottom of the MoreOrLess container; used to calculate expanded and collapsed height. Defaults to 0.*/
        paddingBottom: PropTypes.number
    }

    static defaultProps = {
        expanded: false,
        lineHeight: 22,
        lines: 0,
        onExpandedChange: () => {},
        paddingBottom: 0
    }

    constructor(props) {
        super(props);

        this.state = {
            autoHeight: this.props.expanded,
            displayNone: !this.props.expanded && this.props.lines === 0,
            isExpanded: this.props.expanded
        };
    }

    componentDidUpdate(prevProps) {
        const {expanded} = this.props;
        if (expanded !== prevProps.expanded) {
            if (!expanded) {
                // Collapsing. Set container back to fixed height to allow
                // transition animation to work.
                this.setState({ // eslint-disable-line
                    autoHeight: false
                });
            }
            // Slight delay so the fixed height is rendered and then the
            // container can be collapsed/expand. 25ms seems to be the least we
            // can do for Firefox.
            window.setTimeout(() => {
                this.setState({
                    isExpanded: expanded
                });
            }, 25);
        }
    }

    getCompactHeight() {
        return this.props.lineHeight * this.props.lines;
    }

    getMaxHeight() {
        return this.container.scrollHeight + this.props.paddingBottom;
    }

    handleTransitionEnd = () => {
        // After the container has transitioned to expanded, set height of
        // container to auto to allow reflow on browser resize.
        if (this.state.isExpanded) {
            this.setState({
                autoHeight: true,
                displayNone: false
            });
        } else if (this.props.lines === 0) {
            this.setState({
                displayNone: true
            });
        }
    }

    render() {
        const {id, lines, children, className, expanded, paddingBottom, lineHeight, onExpandedChange, ...rest} = this.props; // eslint-disable-line no-unused-vars
        const {autoHeight, displayNone, isExpanded} = this.state;
        const divClassName = classNames('CollapseBase__content', className);
        const moreStyle = !autoHeight ? {
            maxHeight: (isExpanded) ? `${this.getMaxHeight()}px` : `${this.getCompactHeight()}px`
        } : {};

        return (
            <div
                id={id}
                style={moreStyle}
                className={classNames('CollapseBase', {'CollapseBase--expanded': isExpanded && autoHeight})}
                hidden={displayNone && !expanded}
                onTransitionEnd={this.handleTransitionEnd}
                {...rest}
                ref={
                    /* istanbul ignore next */
                    (c) => {
                        this.container = c;
                    }
                }
            >
                <div
                    className={divClassName}
                >
                    {children}
                </div>
            </div>
        );
    }
}

export default CollapseBase;
